
const AWS = require('aws-sdk');
const { SuccessResponse, ErrorResponse, ERROR } = require("./response");
const { Stage, Stack, Region} = require("./env");

const create_client = (creds) => {
  if (creds) {
    return new AWS.EventBridge(creds.to_service());
  }

  return new AWS.EventBridge({
    region: Region.region,
  });
}

let VERB = false;

if (process.env.CA_EVENT_BRIDGE_DEBUG) {
  VERB = process.env.CA_EVENT_BRIDGE_DEBUG;
}

const SET_VERB = verb => {
  VERB = verb;
}

const PutEvents = async (event_bus, source, events) => {
  return await PutEventsC(null, event_bus, source, events);
}

/**
 * @param creds {CaCredentials|null}
 * @param event_bus {string}
 * @param source { string }
 * @param events { [ { detail_type: string, body: any }]}
 */
const PutEventsC = async (creds, event_bus, source, events) => {
  const params = {
    Entries: [],
  };
  events.forEach(event => {
    params.Entries.push({
      Detail: JSON.stringify(event.body),
      DetailType: event.detail_type,
      EventBusName: event_bus,
      Source: source,
    })
  });

  const eb = create_client();
  try {
    if (VERB) {
      console.log("aws-eventbridge: putEvents", params);
    }
    return SuccessResponse(await eb.putEvents(params).promise());
  } catch (err) {
    if (VERB) {
      console.log(err);
    }
    return ErrorResponse(err);
  }
}

// Generates a stage-stack:/location
const GetSource = location => {
  return Stage.stage + "-" + Stack.stack + ":" + location;
}

module.exports = {
  PutEvents, GetSource, SET_VERB,
}
